import React from 'react';
import EventLabelingChart from './EventLabellingChart';
import { parseLineChartData } from './HighChartUtils';

class LineChart extends React.Component {
  constructor(props) {
    super(props);
  }

  getSentiment(seriesName) {
    return [seriesName];
  }

  render() {
    return (
      <EventLabelingChart
        {...this.props}
        parseChartData={parseLineChartData}
        getSentiment={this.getSentiment}
      />
    )
  }
}

export default LineChart;



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/LineChart.js